import { OrderCallStatus, OrderCallType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useCreateCallOutcome } from "Order/Api/Mutation/createOrderCallOutcomeMutation";
import { isCallOutcomeOpenAtom } from "Order/Atom/callOutcomeOpen";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";
import { SlideCard } from "Shared/Components/Cards/SlideCard";
import { Call, CallEnd, Close } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";

const callResources = Resources.base.order.callOutcome;

type CallOutcomeCardProps = {
	phoneNumber: string;
	orderId: number;
};

export const CallOutcomeCard: FC<CallOutcomeCardProps> = ({
	phoneNumber,
	orderId,
}) => {
	const { t } = useResource();
	const [isCallOutcomeOpen, setIsCallOutcomeOpen] = useAtom(
		isCallOutcomeOpenAtom,
	);

	const { user } = useUser();

	const { mutate: createCallOutcome } = useCreateCallOutcome(orderId);

	const submit = (callStatus: OrderCallStatus) => {
		if (!user?.id) return;
		createCallOutcome({
			type: OrderCallType.inbound,
			status: callStatus,
			operatorId: String(user.id),
		});
		setIsCallOutcomeOpen(false);
	};

	const closeCallOutcomeCard = () => {
		setIsCallOutcomeOpen(false);
	};
	return (
		<SlideCard
			open={isCallOutcomeOpen}
			title={t(callResources.label)}
			customWidth={{
				xs: "92%",
				sm: "320px",
			}}
			action={
				<Box
					sx={{
						transition: "opacity 0.25s ease",
						opacity: 1,
						"&:hover": {
							opacity: 0.7,
						},
						cursor: "pointer",
					}}
					onClick={closeCallOutcomeCard}
				>
					<Close sx={{ width: 20, height: 20 }} />
				</Box>
			}
		>
			<Stack rowGap={3} justifyContent="center" alignItems="center">
				<Typography variant="h2">{phoneNumber}</Typography>
				<Stack direction="row" justifyContent="space-between" width="100%">
					<Button
						variant="outlined"
						color="success"
						startIcon={<Call />}
						onClick={() => submit(OrderCallStatus.answered)}
					>
						<Typography>{t(callResources.acceptedCall)}</Typography>
					</Button>
					<Button
						variant="outlined"
						color="error"
						startIcon={<CallEnd />}
						onClick={() => submit(OrderCallStatus.no_answer)}
					>
						<Typography>{t(callResources.declinedCall)}</Typography>
					</Button>
				</Stack>
			</Stack>
		</SlideCard>
	);
};
